import { IconDefinition } from '@fortawesome/pro-light-svg-icons';
import { faGear as falGear } from '@fortawesome/pro-light-svg-icons/faGear';
import { faHouse as falHouse } from '@fortawesome/pro-light-svg-icons/faHouse';
import { faMagnifyingGlassChart as falMagnifyingGlassChart } from '@fortawesome/pro-light-svg-icons/faMagnifyingGlassChart';
import { faPeopleRoof as falPeopleRoof } from '@fortawesome/pro-light-svg-icons/faPeopleRoof';
import { faUserGraduate as falUserGraduate } from '@fortawesome/pro-light-svg-icons/faUserGraduate';
import { faQrcode } from '@fortawesome/pro-regular-svg-icons';
import { faGear as fasGear } from '@fortawesome/pro-solid-svg-icons/faGear';
import { faHouse as fasHouse } from '@fortawesome/pro-solid-svg-icons/faHouse';
import { faMagnifyingGlassChart as fasMagnifyingGlassChart } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlassChart';
import { faPeopleRoof as fasPeopleRoof } from '@fortawesome/pro-solid-svg-icons/faPeopleRoof';
import { faUserGraduate as fasUserGraduate } from '@fortawesome/pro-solid-svg-icons/faUserGraduate';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Grid, Stack } from "@mui/material";
import { AppGlobalClassKeys } from "app/appGlobalStyles";
import { PermissionExplorer } from "app/appPermissions";
import { TFunction } from "i18next";
import { useSession } from "providers/SessionProvider";
import * as React from "react";
import { useState } from 'react';
import { useTranslation } from "react-i18next";
import { DashboardPaths } from 'routes/DashboardRouter';
import { FoundationPaths } from "routes/FoundationRouter";
import { KnowledgePaths } from "routes/KnowledgeRouter";
import { LmsPaths } from 'routes/LmsRouter';
import { QrCodeAccess } from 'views/foundation/user/dialogs/QrCodeAccess';
import { OutsideOptions, useOutsideLayout } from "./OutsideLayoutProvider";

type MenuOptions = {
    option: OutsideOptions;
    icon: IconDefinition;
    selectedIcon: IconDefinition;
    gap?: number;
    title: string;
};

const buildMenuItems = (pe: PermissionExplorer, t: TFunction): MenuOptions[] => {

    var items: MenuOptions[] = [
        { option: "home", icon: falHouse, selectedIcon: fasHouse, title: t("App.Menu.Sidebar.Home") },
        { option: "lms", icon: falUserGraduate, selectedIcon: fasUserGraduate, title: t("App.Menu.Sidebar.Lms") },
        { option: "knowledge", icon: falPeopleRoof, selectedIcon: fasPeopleRoof, title: t("App.Menu.Sidebar.Knowledge") },
        // { option: "performance", icon: falChartUser, selectedIcon: fasChartUser, title: t("App.Menu.Sidebar.Performance") },
        // { option: "feedback", icon: falHandshake, selectedIcon: fasHandshake, title: t("App.Menu.Sidebar.Feedback") },
        // { option: "career", icon: falArrowUpRightDots, selectedIcon: fasArrowUpRightDots, title: t("App.Menu.Sidebar.Career") },
        { option: "dashboard", icon: falMagnifyingGlassChart, selectedIcon: fasMagnifyingGlassChart, gap: 3, title: t("App.Menu.Sidebar.Dashboard") },
    ];

    if (pe.canViewSetup) {
        items.push({ option: "setup", icon: falGear, selectedIcon: fasGear, title: t("App.Menu.Sidebar.Setup") });
    }

    return items;
};

export const SideBarFindCurrentOption = (): OutsideOptions => {
    var pathname = document.location.pathname.toLowerCase();
    if (pathname.indexOf(FoundationPaths.Prefix) > -1) return "setup";
    if (pathname.indexOf(LmsPaths.Prefix) > -1) return "lms";
    if (pathname.indexOf(KnowledgePaths.Prefix) > -1) return "knowledge";
    if (pathname.indexOf(DashboardPaths.Prefix) > -1) return "dashboard";
    return "home";
};

export const Sidebar: React.FC = (props) => {
    const session = useSession();
    const { t } = useTranslation("shared");
    const { changeOption, selectedOption } = useOutsideLayout();
    const menuItems = buildMenuItems(session.permissionExplorer, t);
    const [showQrCode, setShowQrCode] = useState(false);

    return (
        <>
            <Stack direction="column" height="100%" justifyContent="space-between" alignItems="center">
                <Grid container justifyContent="center" alignItems="center" spacing={2}>
                    {
                        menuItems.map((m, index) => {
                            var selected = m.option == selectedOption;
                            return (
                                <Grid key={index}>
                                    <Box sx={{ color: (theme) => selected ? theme.extended.workArea.sideBar.selectedColor : undefined }}>
                                        <FontAwesomeIcon
                                            title={m.title}
                                            icon={selected ? m.selectedIcon : m.icon}
                                            className={AppGlobalClassKeys.clickable}
                                            onClick={() => changeOption(m.option)}
                                        />
                                    </Box>
                                </Grid>
                            );
                        })
                    }
                </Grid>
                <Box pb={2}>
                    <FontAwesomeIcon
                        title={t("core:Auth.QrCode.Title")}
                        icon={faQrcode}
                        className={AppGlobalClassKeys.clickable}
                        onClick={() => setShowQrCode(true)}
                    />
                </Box>
            </Stack>

            {showQrCode && <QrCodeAccess onClose={() => setShowQrCode(false)} />}
        </>
    );
};
